import React, { useEffect, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { SplitButton } from "primereact/splitbutton";
import { InputText } from 'primereact/inputtext';
// import { CSVLink } from "react-csv";
import { useNavigate } from 'react-router-dom'
import { CommonButton } from "../Buttons/Buttons";
import { FilterMatchMode } from 'primereact/api';
import { CustomStockToolbar } from 'components/CustomStockToolbar';


export const TableStock = ({
    // data task
    ref,
    data,
    selectedData,
    setSelectedData,
    loading = true,
    dataKey,
    tableHeaderName,
    setShowCreateModal,
    searchField = false,
    exportBtn,

    // row task
    rows = 5,
    isRowSelectable = false,

    // column task
    tableColumns,
    sortable = false,
    actionButton,
    actionHeader,
    actionButtonWidth = 8,

    // pagination task
    paginator = true,
    hideLeftToolbar = false,

    ...rest
}) => {

    /**@tableHeaderName => Table Header Name/ table name */

    /**@data => state for table data*/
    /**@loading => loading state=> true / false*/
    /**@selectedData / @setSelectedData => state for selected data */
    /**@dataKey => unique id of the field */
    /**@setShowCreateModal => Modal open close state => true / false*/

    /**@tableColumns => tableColumns you want*/
    /**@sortable => If you want to show shorting*/
    /**@actionButton => Action button of the field */

    /**@isRowSelectable => select box on the left=> ex: true / false */
    /**@rows => total rows you want=> ex: 10 */


    const [tableData, setTableData] = useState([]);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    useEffect(() => {
        if (typeof data === "undefined" || data === null) {
            return setTableData([]);
        }
        setTableData(data);
    }, [data]);


    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    }


    const renderHeader = () => {
        return (
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <span style={{float: 'left', 'fontWeight': 'bold', 'fontSize': 'large'}}>
                    {tableHeaderName}
                </span>
                {
                    searchField && (
                    <span style={{float: 'right'}}>
                        <span className="p-input-icon-left" style={{'textAlign': 'right'}}>
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" className="text-lg"/>
                        </span>
                    </span>
                    )
                }
                
            </div>
        )
    }

    const header = renderHeader();

    return (
        <>
            <CustomStockToolbar selectedData={selectedData} setShowCreateModal={setShowCreateModal} exportBtn={exportBtn} hideLeftToolbar={hideLeftToolbar} />
            
            <div className="datatable-filter-demo">
                <div className="card">
                    <DataTable
                        className="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-customers"
                        ref={ref}
                        // Data manage
                        value={tableData}
                        dataKey={dataKey}
                        loading={loading}
                        emptyMessage="Sorry, no matching records found !!!"
                        //row manage
                        rowHover
                        selection={selectedData}
                        onSelectionChange={(e) => setSelectedData?.(e.value)}
                        paginator={paginator}
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} items"
                        rows={rows}
                        rowsPerPageOptions={[5, 10, 25, 50, 75, 100]}

                        //column manage
                        resizableColumns
                        columnResizeMode="expand"

                        // filter manage
                        filters={filters}

                        //header manage
                        header= {header}

                        //extra
                        // autoLayout={true}
                        // responsiveLayout="scroll"

                        //filter
                        filterDisplay="row"

                        {...rest}
                    >
                        { isRowSelectable && (
                            <Column
                                selectionMode="multiple"
                                headerStyle={{ width: "4em", alignItems: "center", justifyContent: "center", textAlign: "center", backgroundColor: "#0000FF !important" }}
                                bodyStyle={{ width: "4em", alignItems: "center", justifyContent: "center", textAlign: "center" }}
                            ></Column>
                        )}

                        {tableColumns?.map((col, i) => (
                            <Column key={i} 
                            field={col.field} 
                            header={col.header} 
                            sortable={sortable} 
                            body={col.sortableBody}
                            style={{ minWidth: col.minWidth }} 
                            onRowClick={null} />
                        ))}

                        {actionButton && <Column body={actionButton} header={actionHeader || "Action"} headerStyle={{ textAlign: "center", width: `${actionButtonWidth}rem` }}></Column>}
                    </DataTable>
                </div>
            </div>
        </>

    );
};
